import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import { useSelector } from "../../../../store";

export default function WebFillInTheBlankAlphabet({ question, onAnswer = () => {} }) {
    const questionData = question
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;

    const [answers, setAnswers] = useState(data.initialState);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAnswers([]);
    }, [question]);

    const handleChange = (index, event) => {
        const newAnswers = [...answers];
        newAnswers[index] = data.isUpperCase ? event.target.value.toUpperCase() : event.target.value;
        setAnswers(newAnswers);

        const finalAnswerData = newAnswers.filter((value) => value !== "")
        const canProceed = finalAnswerData.length > 0;
        onAnswer({
            canProceed,
            answer: finalAnswerData,
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                backgroundColor: "white",
                padding: 2,
                maxWidth: 725,
                margin: "0 auto",
            }}
        >
            {data.elements[0].children[0].children.map((element, index) => {
                if (element.type === "div") {
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: "inline-block",
                                width: "70px",
                                height: "75px",
                                fontWeight: "bold",
                                margin: "10px",
                                fontSize: "42px",
                                padding: "10px",
                                backgroundColor: "rgb(217, 217, 217)",
                                borderBottom: "5px solid rgb(89, 89, 89)",
                                textAlign: "center",
                            }}
                        >
                            {element.children}
                        </Box>
                    );
                } else if (element.type === "Input") {
                    const stateKey = element.stateKey;
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: "inline-block",
                                margin: "10px",
                            }}
                        >
                            <TextField
                                value={answers[stateKey] || ""}
                                onChange={(e) => handleChange(stateKey, e)}
                                inputProps={{
                                    autoComplete: 'off',
                                    maxLength: element.maxLength,
                                    style: {
                                        fontSize: "42px",
                                        textAlign: "center",
                                        width: "70px",
                                        height: "75px",
                                        padding: "10px",
                                    },
                                }}
                                variant="standard"
                                sx={{
                                    "& .MuiInput-underline:before": {
                                        borderBottom:
                                            "2px solid rgb(136, 136, 136)",
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottom:
                                            "2px solid #00b0f0",
                                    },
                                    "& .MuiInputBase-root": {
                                        "&:hover:not(.Mui-disabled):before": {
                                            borderBottom:
                                                "2px solid rgb(136, 136, 136)",
                                        },
                                    },
                                }}
                            />
                        </Box>
                    );
                }
                return null;
            })}
        </Box>
    );
};
